"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARD_CATEGORY_KEY = 'base';
exports.CARD_COMPONENT_KEY = 'card';